/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    reportsToSectionTitle: 'Reports to',
    directReportsSectionTitle: 'Direct reports',
    organizationSectionTitle: 'Organization',
    youWorkWithSubSectionTitle: 'You work with',
    userWorksWithSubSectionTitle: 'works with'
};
//# sourceMappingURL=strings.js.map